import store from '../store'

const detectDevice = () => {
  let width = document.body.clientWidth
  if (width < 576) {
    store.commit('setDevice', 'mobile')
  } else if (width < 1199) {
    store.commit('setDevice', 'tablet')
  } else {
    store.commit('setDevice', 'desktop')
  }
}
detectDevice()
window.addEventListener('resize', detectDevice)
